import { usePublicMarketStats } from '../../hooks/use-public-market-stats';

const FALLBACK = { priceChangesLast24h: 4_000, bookingsLast24h: 2_000 };

export function LandingTicker() {
  const { data } = usePublicMarketStats();
  const stats = data ?? FALLBACK;

  return (
    <div
      role="status"
      aria-live="polite"
      className="font-mono tabular-nums text-xs text-muted-foreground flex flex-wrap items-center justify-center gap-x-6 gap-y-2 border-y border-border py-3"
    >
      <span className="flex items-center gap-2">
        <span className="size-1.5 rounded-full bg-emerald-500 animate-pulse" />
        <span className="uppercase tracking-wider">LIVE · last 24h</span>
      </span>
      <span>↑ {stats.priceChangesLast24h.toLocaleString()} price changes</span>
      <span>↑ {stats.bookingsLast24h.toLocaleString()} new bookings</span>
    </div>
  );
}
